<template>
  <div class="recover">
    <div class="recover__wrapper">
      <img class="recover__logo" src="../assets/images/logo.svg" alt="" />
      <div class="recover__title">Восстановление пароля</div>
      <form class="recover__form" @submit.prevent="recover">
        <div class="recover__form-body">
          <div class="recover__form-text">
            Укажите адрес электронной почты и мы вышлем ссылку для
            восстановления пароля вашей учетной записи
          </div>
          <div class="recover__form-block">
            <div class="recover__form-title">Электронная почта</div>
            <Input
              :type="email.type"
              :name="email.name"
              :value="email.value"
              :status="email.status"
              @input="handleChange"
              @paste="handleChange"
              @change="handleChange"
            />
            <span class="recover__form-error" v-if="email.error">{{
              email.error
            }}</span>
          </div>
        </div>
        <div class="recover__form-footer">
          <Button
            :type="'text'"
            :value="'Отправить'"
            :paint="'blue'"
            :disabled="!validation"
            @click="handleFormSumbit"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from "vuex";
  import Button from "../components/Button";
  import Input from "../components/Input";

  export default {
    name: "Recover",
    components: {
      Button,
      Input,
    },
    computed: {
      ...mapGetters({
        email: "getRecoverEmail",
        validation: "getRecoverValidation",
      }),
    },
    methods: {
      ...mapMutations(["handleRecoverChanges"]),
      ...mapActions(["sendRecoverChanges", "logoutAuthorization"]),
      handleChange(event) {
        let payload = {
          event: event.type,
          name: event.target.getAttribute("name"),
          value: event.target.value,
        };

        this.handleRecoverChanges(payload);
      },
      handleFormSumbit() {
        this.sendRecoverChanges();
      },
    },
    created() {
      this.logoutAuthorization();
    },
  };
</script>

<style lang="scss" scoped>
  .recover {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;

    @include mediaquery(md) {
      min-height: calc(100vh - 20px);
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      @include mediaquery(sm) {
        width: 400px;
      }
    }

    &__logo {
      width: 50px;
      margin-bottom: 24px;

      @include mediaquery(sm) {
        margin-bottom: 44px;
      }
    }

    &__title {
      width: 100%;
      margin-bottom: 20px;
      text-transform: uppercase;
      text-align: center;
      font-size: 24px;
    }

    &__form {
      @include base;

      width: 100%;
      padding: 20px;

      @include mediaquery(sm) {
        padding: 46px 40px 25px;
      }

      &-body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &-text {
        font-size: 12px;
        text-align: center;
        color: #222325;
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &-block {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 10px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &-title {
        @include title;
      }

      &-error {
        position: absolute;
        top: 100%;
        font-size: 9px;
        color: #ff8068;
      }

      &-footer {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        @include mediaquery(sm) {
          flex-direction: row;
          justify-content: space-between;
        }

        button {
          width: 100%;
        }
      }
    }
  }
</style>